import React from "react";
import { Outlet } from "react-router-dom";

export const InvoicesPage = () => {
  return (
    <div className="settings invoices">
      <Outlet />
    </div>
  );
};

export default InvoicesPage;
